import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-avatar-elite",
  "use": "icon-avatar-elite-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol viewBox=\"0 0 28 28\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-avatar-elite\">\n  <rect width=\"28\" height=\"28\" rx=\"14\" fill=\"#A38F8F\" />\n  <path d=\"M17.2266 18.1484V19.375H11.2031V18.1484H17.2266ZM11.5078 8V19.375H10V8H11.5078ZM16.4297 12.8906V14.1172H11.2031V12.8906H16.4297ZM17.1484 8V9.23438H11.2031V8H17.1484Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol